import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Wrapper, Link, TextWrapper, TextWrapperSpan } from "../../constants/common/StyledGlobalConstants";
import { helpNavigationHandler } from "../../util/helpURLNavigation";
import CPNotification from "./CPNotification";
import PropTypes from "prop-types";

const FailedToLoadData = (props) => {
  const { t } = useTranslation("loginTranslation");

  const refreshpage = () => {
    window.location.reload();
  };

  return (
      <Wrapper>
        <Wrapper marginBottom={"24px"}>
          <TextWrapper fontFamily="neue-haas-grotesk-display" fontSize="40px" fontWeight="700" lineHeight="48px" margin="0">
            {t(`${props?.title}`)}
          </TextWrapper>
        </Wrapper>

        <CPNotification isOpen={true} notificationType="error" width="100%" height="auto">
          <Wrapper>
            <TextWrapperSpan fontSize="14px" fontWeight="400" lineHeight="20px" margin="0">
              {" "}
              {t("Failed to load data")}
              {". "}
            </TextWrapperSpan>
            <Link
              id="refresh-page-link"
              type="standAlone"
              size="large"
              ariaLabel="Refresh page"
              fontFamily="neue-haas-grotesk-text"
              fontSize="0.875rem"
              onClick={refreshpage}
            >
              {t("Refresh page")}
            </Link>
            <TextWrapperSpan fontSize="14px" fontWeight="400" lineHeight="20px" margin="0">
              {" "}
              {t("or")}{" "}
            </TextWrapperSpan>
            <Link
              id="failed-to-load-contact-support-link"
              type="standAlone"
              size="large"
              ariaLabel="Contact support"
              fontSize="0.875rem"
              fontFamily="neue-haas-grotesk-text"
              onClick={() => helpNavigationHandler(props.regionId, "Customer Portal | Help", props.accountNumber, true)}
            >
              {t("contact Support")}
            </Link>{" "}
          </Wrapper>
        </CPNotification>
      </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    regionId: state.ACCOUNT.regionId,
    accountNumber: state.ACCOUNT.accountNumber,
    windowSize: state.ACCOUNT.windowSize,
  };
};

FailedToLoadData.propTypes = {
  title: PropTypes.string,
  regionId: PropTypes.string,
  accountNumber: PropTypes.string,
};

export default connect(mapStateToProps)(FailedToLoadData);